import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";

import { getMenuList } from "../services/menuService";
import { placeOrder as placeOrderApi } from "../services/orderService";
import { formatCurrency } from "../utils/currency";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import "../styles/theme.css";
import Carousel from "bootstrap/js/dist/carousel";
toastr.options = {
  closeButton: true,
  progressBar: true,
  positionClass: "toast-top-right",
  timeOut: "3000",
};

const TastyBites = ({
  cart,
  setCart,
  isCartOpen,
  setIsCartOpen,
  table,
  settings,
  setSettings,
  setTable,
  setHashcode,
}) => {
  // const [cart, setCart] = useState(() => {
  //   const savedCart = localStorage.getItem("tastybites_cart");
  //   return savedCart ? JSON.parse(savedCart) : [];
  // });

  const { hashcode } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  // REMOVE THIS LINE: const [cart, setCart] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All Items");
  const [offers, setOffers] = useState([]);
  const [showVariantModal, setShowVariantModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedInstructions, setSelectedInstructions] = useState([]);
  const [customInstruction, setCustomInstruction] = useState("");
  useEffect(() => {
    // Check if user is logged in
    const userData = localStorage.getItem("user");

    if (userData && userData !== "undefined") {
      setUser(JSON.parse(userData));
    }

    getMenuList(hashcode)
      .then((res) => {
        if (res.success && Array.isArray(res.data)) {
          setMenuItems(res.data); // ✅ CORRECT
          setSettings(res.settings); // 👈 store tax settings
          setTable(res.table);
          setOffers(Array.isArray(res.offers) ? res.offers : []);
        } else {
          setMenuItems([]);
          setOffers([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const carouselElement = document.querySelector("#offerCarousel");
    if (carouselElement) {
      new Carousel(carouselElement, {
        interval: 3000,
        ride: "carousel",
        pause: false,
      });
    }
  }, [offers]);
  // Categories for filtering

  // Add item to cart
  const addToCart = (item) => {
    const hasVariants = item.variants && item.variants.length > 0;
    const hasInstructions = item.instructions && item.instructions.length > 0;

    // open modal if either exists
    if (hasVariants || hasInstructions) {
      setSelectedItem(item);

      if (hasVariants) {
        setSelectedVariant(item.variants[0]);
      } else {
        setSelectedVariant(null);
      }

      setSelectedInstructions([]);
      setCustomInstruction("");
      setShowVariantModal(true);
      return;
    }

    // direct add if no variants and no instructions
    addItemToCart(item, null, []);
  };

  const addItemToCart = (item, variant, instructions = []) => {
    if (customInstruction.length > 80) {
      toastr.error("Special instruction cannot exceed 80 characters.");
      return;
    }
    const selectedInstructionText = instructions.map((i) => i.instruction);

    if (customInstruction.trim() !== "") {
      selectedInstructionText.push(customInstruction.trim());
    }

    const instructionText = selectedInstructionText.join("###");

    const cartId = variant
      ? `${item.id}-${variant.id}-${instructionText}`
      : `${item.id}-${instructionText}`;

    const priceToUse = variant ? variant.price : item.price;

    setCart((prevCart) => {
      const existing = prevCart.find((c) => c.cartId === cartId);

      if (existing) {
        return prevCart.map((c) =>
          c.cartId === cartId ? { ...c, quantity: c.quantity + 1 } : c
        );
      }

      return [
        ...prevCart,
        {
          ...item,
          cartId,
          variant,
          price: priceToUse,
          instructions: instructionText,
          quantity: 1,
        },
      ];
    });

    setShowVariantModal(false);
    setIsCartOpen(true);
    setCustomInstruction("");
  };

  // Increment item quantity
  const incrementItem = (cartId) => {
    setCart(
      cart.map((item) =>
        item.cartId === cartId ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  // Decrement item quantity
  const decrementItem = (cartId) => {
    const item = cart.find((item) => item.cartId === cartId);

    if (item.quantity === 1) {
      removeFromCart(cartId);
    } else {
      setCart(
        cart.map((item) =>
          item.cartId === cartId
            ? { ...item, quantity: item.quantity - 1 }
            : item
        )
      );
    }
  };

  const incrementItemByMenuId = (menuId) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === menuId ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const decrementItemByMenuId = (menuId) => {
    setCart((prevCart) => {
      const existing = prevCart.find((item) => item.id === menuId);

      if (!existing) return prevCart;

      if (existing.quantity === 1) {
        return prevCart.filter((item) => item.id !== menuId);
      }

      return prevCart.map((item) =>
        item.id === menuId ? { ...item, quantity: item.quantity - 1 } : item
      );
    });
  };

  // Remove item from cart
  const removeFromCart = (cartId) => {
    setCart(cart.filter((item) => item.cartId !== cartId));
  };

  // Calculate cart totals
  const calculateTotals = () => {
    const subtotal = cart.reduce(
      (total, item) => total + Number(item.price) * item.quantity,
      0
    );

    let taxAmount = 0;
    let total = subtotal;

    if (settings?.is_tax_enabled && settings?.taxes?.length > 0) {
      const totalTaxRate = settings.taxes.reduce(
        (sum, tax) => sum + Number(tax.tax_rate),
        0
      );

      if (settings.tax_type === "exclusive") {
        taxAmount = (subtotal * totalTaxRate) / 100;
        total = subtotal + taxAmount;
      } else if (settings.tax_type === "inclusive") {
        taxAmount = (subtotal * totalTaxRate) / (100 + totalTaxRate);
        total = subtotal; // already included
      }
    }

    return {
      subtotal: subtotal.toFixed(2),
      tax: taxAmount.toFixed(2),
      total: total.toFixed(2),
    };
  };

  // Place order

  const placeOrder = async () => {
    if (cart.length === 0) return;

    const orderPayload = {
      hashcode: hashcode,
      session_id: "c8b5e5f2-4d9b-4f17-9c71-2e8f4c9a12d3",
      order_type: "dine-in",
      special_instructions: "Serve starters first",
      items: cart.map((item) => {
        const baseItem = {
          menu_id: item.id,
          quantity: item.quantity,
          special_instructions: item.instructions || "",
        };

        // Add variant_id only if variant exists
        if (item.variant) {
          baseItem.variant_id = item.variant.id;
        }

        return baseItem;
      }),
    };

    try {
      const response = await placeOrderApi(orderPayload);
      console.log(response);
      if (response.success) {
        toastr.success("Order placed successfully!");
        setCart([]);
        localStorage.removeItem("tasty_cart");
        setIsCartOpen(false);
      } else {
        toastr.error(response.message || "Failed to place order");
      }
    } catch (err) {
      toastr.error("Server error. Please try again.");
    }
  };

  // Get total items in cart
  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  const updateItemInstruction = (cartId, value) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.cartId === cartId ? { ...item, special_instructions: value } : item
      )
    );
  };

  // Get quantity for a specific item
  const getItemQuantity = (id) => {
    const items = cart.filter((item) => item.id === id);
    return items.reduce((sum, item) => sum + item.quantity, 0);
  };

  const toggleInstruction = (instruction) => {
    setSelectedInstructions((prev) => {
      const exists = prev.find((i) => i.id === instruction.id);

      if (exists) {
        return prev.filter((i) => i.id !== instruction.id);
      }

      return [...prev, instruction];
    });
  };

  // Render food type indicator
  const renderFoodTypeIndicator = (type = "vegetarian") => {
    let borderClass = "border-success";
    let iconClass = "text-success";
    let title = "Vegetarian";

    switch (type) {
      case "non_vegetarian":
        borderClass = "border-danger";
        iconClass = "text-danger";
        title = "Non Vegetarian";
        break;

      case "eggetarian":
        borderClass = "border-warning";
        iconClass = "text-warning";
        title = "Eggetarian";
        break;

      case "vegetarian":
      default:
        borderClass = "border-success";
        iconClass = "text-success";
        title = "Vegetarian";
    }

    return (
      <div
        className={`position-absolute top-0 end-0 border ${borderClass} rounded d-inline-flex align-items-center justify-content-center m-2`}
        style={{ width: "22px", height: "22px" }}
        title={title}
      >
        <i
          className={`fas fa-circle ${iconClass}`}
          style={{ fontSize: "12px" }}
        ></i>
      </div>
    );
  };

  // Filter menu items by category

  // Group menu items by category
  const menuItemsByCategory = menuItems.reduce((groups, item) => {
    const category = item.category || "Others";

    if (!groups[category]) {
      groups[category] = [];
    }

    groups[category].push(item);
    return groups;
  }, {});

  const categories = ["All Items", ...Object.keys(menuItemsByCategory)];
  const visibleCategories =
    activeCategory === "All Items"
      ? Object.keys(menuItemsByCategory)
      : [activeCategory];

  return (
    <div className={`tasty-bites-app ${isCartOpen ? "cart-open" : ""}`}>
      {/* Toast Container */}
      <div className="toast-container"></div>

      {/* Cart Overlay */}
      {isCartOpen && (
        <div
          className="cart-overlay"
          onClick={(e) => {
            setIsCartOpen(false);
          }}
        ></div>
      )}

      {/* Category Navigation */}
      <div className="category-nav py-2">
        <div className="container">
          <div className="d-flex category-scroll">
            {categories.map((category) => (
              <button
                key={category}
                className={`btn btn-outline-secondary category-btn ${
                  activeCategory === category ? "active" : ""
                }`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container">
        {/* Responsive Banner */}

        {offers.length > 0 ? (
          <div className="banner rounded-3 overflow-hidden">
            <div
              id="offerCarousel"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              {/* Indicators */}
              <div className="carousel-indicators">
                {offers.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    data-bs-target="#offerCarousel"
                    data-bs-slide-to={index}
                    className={index === 0 ? "active" : ""}
                  ></button>
                ))}
              </div>

              {/* Slides */}
              <div className="carousel-inner">
                {offers.map((offer, index) => (
                  <div
                    key={offer.id}
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                  >
                    <img
                      src={offer.banner_image_url}
                      className="d-block w-100"
                      alt={offer.heading}
                      style={{ height: "250px", objectFit: "cover" }}
                    />

                    {/* Optional Text Overlay */}
                    {(offer.heading || offer.description) && (
                      <div className="carousel-caption d-none d-md-block bg-dark bg-opacity-50 rounded p-2">
                        <h5>{offer.heading}</h5>
                        <p>{offer.description}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Controls */}
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#offerCarousel"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon"></span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#offerCarousel"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon"></span>
              </button>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          {/* Menu Items */}
          <div className="col-lg-8">
            {visibleCategories.map((category) => (
              <div key={category} className="menu-section">
                <h3 className="section-title">{category}</h3>

                <div className="row">
                  {menuItemsByCategory[category]?.map((item) => {
                    const quantity = getItemQuantity(item.id);
                    const hasVariants =
                      item.variants && item.variants.length > 0;

                    return (
                      <div key={item.id} className="col-md-6 mb-4">
                        <div className="card menu-item-card p-3">
                          <div className="position-relative">
                            <img
                              src={item.image_url}
                              className="card-img-top menu-item-image"
                              alt={item.name}
                            />

                            {renderFoodTypeIndicator(
                              item.diet_type || "vegetarian"
                            )}
                          </div>

                          <div className="card-body">
                            <h5 className="card-title">{item.name}</h5>
                            <p className="card-text">{item.description}</p>

                            <div className="d-flex justify-content-between align-items-center">
                              {/* ===== PRICE SECTION ===== */}
                              <div>
                                {hasVariants ? (
                                  <div className="variant-prices">
                                    {item.variants.map((variant) => (
                                      <div
                                        key={variant.id}
                                        className="d-flex justify-content-between small"
                                      >
                                        <span className="me-3">
                                          {variant.name}
                                        </span>
                                        <span className="h6">
                                          {formatCurrency(
                                            Number(
                                              settings?.tax_type === "exclusive"
                                                ? variant.price
                                                : variant.ac_price
                                            ).toFixed(2),
                                            settings?.currency
                                          )}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <span className="h5 mb-0">
                                    {formatCurrency(
                                      Number(
                                        settings?.tax_type === "exclusive"
                                          ? item.price
                                          : item.ac_price
                                      ).toFixed(2),
                                      settings?.currency
                                    )}
                                  </span>
                                )}
                              </div>

                              {/* ===== QUANTITY / ADD BUTTON ===== */}
                              <div className="quantity-controls">
                                {quantity > 0 ? (
                                  <>
                                    <button
                                      className="btn btn-sm btn-outline-secondary quantity-btn"
                                      onClick={() =>
                                        decrementItemByMenuId(item.id)
                                      }
                                    >
                                      <i className="fas fa-minus"></i>
                                    </button>

                                    <span className="quantity-display">
                                      {quantity}
                                    </span>

                                    <button
                                      className="btn btn-sm btn-outline-primary quantity-btn"
                                      onClick={() =>
                                        incrementItemByMenuId(item.id)
                                      }
                                    >
                                      <i className="fas fa-plus"></i>
                                    </button>
                                  </>
                                ) : (
                                  <button
                                    className="btn btn-primary add-btn"
                                    onClick={() => addToCart(item)}
                                  >
                                    <i className="fas fa-plus me-1"></i> Add
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Table Info & Instructions */}
          <div className="col-lg-4">
            <div className="sticky-top" style={{ top: "112px", zIndex: 1010 }}>
              <div className="table-info mb-4">
                <h5>
                  <i className="fas fa-table me-2"></i>Table Information
                </h5>
                <p className="mb-1">
                  <strong>Table: {table.table_name}</strong>
                </p>
              </div>

              <div className="card mb-4">
                <div className="card-body">
                  <h5 className="card-title">Special Instructions</h5>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Any special requests for your order..."
                  ></textarea>
                </div>
              </div>

              <div className="d-grid">
                <button className="btn btn-primary btn-lg" onClick={placeOrder}>
                  <i className="fas fa-paper-plane me-2"></i>Place Order
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Cart Sidebar */}
      <div className={`cart-sidebar ${isCartOpen ? "" : "cart-hidden"}`}>
        <div className="p-3 border-bottom">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Your Order</h5>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => setIsCartOpen(false)}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div className="p-3 cart-sidebar-container">
          <div className="cart-items">
            {cart.length === 0 ? (
              <p className="text-center text-muted py-3">Your cart is empty</p>
            ) : (
              cart.map((item) => (
                <div key={item.cartId} className="cart-item mb-3">
                  <div className="d-flex justify-content-between">
                    <div style={{ width: "70%" }}>
                      <h6 className="mb-0">{item.name}</h6>

                      {/* Variant Name */}
                      {item.variant && (
                        <div className="small text-muted">
                          {item.variant.name}
                        </div>
                      )}

                      <small className="text-muted">
                        {formatCurrency(
                          Number(item.price).toFixed(2),
                          settings?.currency
                        )}{" "}
                        × {item.quantity}
                      </small>

                      {/* Quantity Controls */}
                      <div className="cart-quantity-controls mt-2">
                        <button
                          className="btn btn-sm btn-outline-secondary cart-quantity-btn"
                          onClick={() => decrementItem(item.cartId)}
                        >
                          <i className="fas fa-minus"></i>
                        </button>

                        <span className="cart-quantity-display mx-2">
                          {item.quantity}
                        </span>

                        <button
                          className="btn btn-sm btn-outline-primary cart-quantity-btn"
                          onClick={() => incrementItem(item.cartId)}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      </div>

                      {typeof item.instructions === "string" &&
                        item.instructions.split("###").map((ins, index) => (
                          <span
                            style={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              textAlign: "left",
                            }}
                            key={index}
                            className="badge bg-secondary me-1 mt-2"
                          >
                            {ins}
                          </span>
                        ))}

                      {/* Special Instructions */}
                    </div>

                    <div className="d-flex flex-column align-items-end justify-content-between">
                      <span>
                        {formatCurrency(
                          Number((item.price * item.quantity).toFixed(2)),
                          settings?.currency
                        )}
                      </span>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => removeFromCart(item.cartId)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {cart.length > 0 && (
            <div className="mt-3 pt-3 border-top">
              <div className="d-flex justify-content-between mb-2">
                <span>Subtotal:</span>
                <span>
                  {formatCurrency(
                    Number(calculateTotals().subtotal),
                    settings?.currency
                  )}
                </span>
              </div>

              {settings?.is_tax_enabled &&
                settings?.taxes?.map((tax, index) => (
                  <div
                    className="d-flex justify-content-between mb-2"
                    key={index}
                  >
                    <span>
                      {tax.tax_name} ({tax.tax_rate}%):
                    </span>
                    <span>
                      {formatCurrency(
                        Number(
                          (
                            (Number(calculateTotals().subtotal) *
                              Number(tax.tax_rate)) /
                            100
                          ).toFixed(2)
                        ),
                        settings?.currency
                      )}
                    </span>
                  </div>
                ))}

              <div className="d-flex justify-content-between mb-3">
                <strong>Total:</strong>
                <strong>
                  {formatCurrency(
                    Number(calculateTotals().total),
                    settings?.currency
                  )}
                </strong>
              </div>

              <div className="d-grid">
                <button className="btn btn-primary" onClick={placeOrder}>
                  <i className="fas fa-check me-1"></i>
                  Proceed to Checkout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Cart Bar */}
      <div className="mobile-cart-bar">
        <div className="d-flex align-items-center">
          <span className="me-2">
            <i className="fas fa-shopping-cart"></i>
          </span>
          <span>
            {getTotalItems()} {getTotalItems() === 1 ? "Item" : "Items"}
          </span>
        </div>
        <div>
          <span className="me-3">${calculateTotals().subtotal}</span>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => setIsCartOpen(true)}
          >
            View Cart
          </button>
        </div>
      </div>

      {showVariantModal && selectedItem && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select Variant Or Instructions</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowVariantModal(false)}
                ></button>
              </div>

              <div className="modal-body variant-modal-body">
                {selectedItem.variants?.length > 0 && (
                  <>
                    <h6>Variants</h6>

                    {selectedItem.variants.map((variant) => (
                      <div key={variant.id} className="form-check mb-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="variant"
                          checked={selectedVariant?.id === variant.id}
                          onChange={() => setSelectedVariant(variant)}
                        />

                        <label className="form-check-label">
                          {variant.name} -{" "}
                          {formatCurrency(variant.price, settings?.currency)}
                        </label>
                      </div>
                    ))}
                    <hr />
                  </>
                )}

                {/* INSTRUCTIONS */}
                {selectedItem.instructions?.length > 0 && (
                  <>
                    <h6>Special Instructions</h6>

                    {selectedItem.instructions.map((instruction) => (
                      <div key={instruction.id} className="form-check mb-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectedInstructions.some(
                            (i) => i.id === instruction.id
                          )}
                          onChange={() => toggleInstruction(instruction)}
                        />

                        <label className="form-check-label">
                          {instruction.instruction}
                        </label>
                      </div>
                    ))}
                  </>
                )}
                <h6 className="mt-3">Custom Instruction</h6>

                <textarea
                  className="form-control"
                  rows="2"
                  placeholder="Add any special request..."
                  value={customInstruction}
                  onChange={(e) => {
                    const value = e.target.value.replace(/#/g, "");
                    setCustomInstruction(value);
                  }}
                ></textarea>

                <small className="text-muted">
                  {80 - customInstruction.length} characters remaining
                </small>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowVariantModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    addItemToCart(
                      selectedItem,
                      selectedVariant,
                      selectedInstructions,
                      customInstruction
                    )
                  }
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx="true">{`
        :root {
          --primary: #2c3e50;
          --secondary: #e74c3c;
          --accent: #3498db;
          --light: #ecf0f1;
          --dark: #2c3e50;
          --success: #27ae60;
        }

        .category-nav {
          background-color: white;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          position: fixed;
          top: 56px;
          width: 100%;
          z-index: 1020;
        }

        .banner {
          background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7));
          background-size: cover;
          background-position: center;
          color: white;
          padding: 40px 0;
          margin-bottom: 30px;
          text-align: center;
        }

        .banner-content {
          max-width: 800px;
          margin: 0 auto;
          padding: 0 15px;
        }

        .banner h1 {
          font-size: 2.5rem;
          font-weight: 700;
          margin-bottom: 15px;
        }

        .banner p {
          font-size: 1.2rem;
          margin-bottom: 20px;
        }

        .banner-btn {
          background-color: var(--secondary);
          border: none;
          padding: 12px 30px;
          font-size: 1.1rem;
          border-radius: 30px;
          transition: all 0.3s;
        }

        .banner-btn:hover {
          background-color: #c0392b;
          transform: translateY(-2px);
        }

        @media (max-width: 768px) {
          .banner {
            padding: 30px 0;
          }

          .banner h1 {
            font-size: 2rem;
          }

          .banner p {
            font-size: 1rem;
          }

          .banner-btn {
            padding: 10px 25px;
            font-size: 1rem;
          }
        }

        @media (max-width: 576px) {
          .banner {
            padding: 20px 0;
          }

          .banner h1 {
            font-size: 1.7rem;
          }

          .banner p {
            font-size: 0.9rem;
          }
        }

        .category-btn {
          transition: all 0.3s;
          border-radius: 20px;
          margin: 0 5px;
          white-space: nowrap;
        }

        .category-btn:hover,
        .category-btn.active {
          background-color: var(--secondary);
          color: white;
        }

        .menu-item-card {
          transition: transform 0.3s, box-shadow 0.3s;
          border: none;
          border-radius: 10px;
          overflow: hidden;
          height: 100%;
        }

        .menu-item-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }

        .menu-item-image {
          height: 180px;
          object-fit: cover;
        }

        .veg-indicator {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: inline-block;
        }

        .veg {
          background-color: green;
          border: 1px solid green;
        }

        .non-veg {
          background-color: var(--secondary);
          border: 1px solid var(--secondary);
        }

        .eggetarian {
          background-color: #ff9800;
          border: 1px solid #ff9800;
        }

        .cart-sidebar {
          background-color: white;
          border-left: 1px solid #dee2e6;
          height: calc(100vh - 56px);
          position: fixed;
          top: 56px;
          right: 0;
          width: 350px;
          overflow-y: auto;
          transition: transform 0.3s ease-in-out;
          z-index: 1040;
          box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
        }

        .cart-hidden {
          transform: translateX(100%);
        }

        .cart-item {
          border-bottom: 1px solid #2a2d33 !important;
          padding: 10px 0;
        }

        .cart-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          background-color: var(--secondary);
          color: white;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          z-index: 1;
        }

        .quantity-btn {
          width: 30px;
          height: 30px;
          border-radius: 20%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          font-size: 14px;
        }

        .food-type-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 1;
        }

        @media (max-width: 768px) {
          body {
            padding-top: 104px;
            padding-bottom: 70px;
          }

          .category-nav {
            top: 56px;
          }

          .cart-sidebar {
            width: 100%;
            z-index: 1040;
          }

          .category-scroll {
            overflow-x: auto;
            flex-wrap: nowrap;
            padding-bottom: 10px;
          }

          .category-btn {
            margin: 0 3px;
            font-size: 0.9rem;
          }
        }

        .table-info {
          background-color: var(--light);
          border-radius: 10px;
          padding: 15px;
        }

        .special-instructions {
          font-size: 0.85rem;
          color: #6c757d;
        }

        .menu-section {
          margin-top: 20px;
        }

        .section-title {
          position: relative;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #eee;
        }

        .section-title::after {
          content: "";
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 60px;
          height: 2px;
          background-color: var(--secondary);
        }

        .cart-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1035;
        }

        .mobile-cart-bar {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          background: white;
          box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
          padding: 10px 15px;
          z-index: 1030;
          display: none;
        }

        @media (max-width: 768px) {
          .mobile-cart-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }

        .toast-container {
          position: fixed;
          top: 120px;
          right: 20px;
          z-index: 1050;
        }

        .quantity-controls {
          display: flex;
          align-items: center;
        }

        .quantity-display {
          margin: 0 10px;
          font-weight: bold;
          min-width: 30px;
          text-align: center;
        }

        .cart-quantity-controls {
          display: flex;
          align-items: center;
          margin-top: 5px;
        }

        .cart-quantity-btn {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          font-size: 12px;
        }

        .cart-quantity-display {
          margin: 0 8px;
          font-weight: bold;
          min-width: 20px;
          text-align: center;
        }

        .add-btn {
          min-width: 90px;
        }
      `}</style>
    </div>
  );
};

export default TastyBites;
